export default {"src":"/_next/static/media/ic-arrow-up.18e6f674.svg","height":9,"width":14,"blurWidth":0,"blurHeight":0};